var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurchase(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 6c0-2.8 2.2-5 5-5s5 2.2 5 5h.5c.5 0 1 .1 1.5.3.7.3 1.3.9 1.7 1.6.3.4.4.9.5 1.4s.1 1.1.2 1.8l.6 5.7v.1c0 3.3-2.7 6-6 6H8c-3.3 0-6-2.7-6-6v-.1l.6-5.7c.1-.7.1-1.3.2-1.8s.2-1 .5-1.4c.4-.7 1-1.2 1.7-1.6.5-.1.9-.2 1.5-.3zM5.9 8.2c.1-.1.3-.1.7-.2h10.7c.4 0 .6.1.8.2.4.2.7.4.9.8.1.1.2.3.2.7.1.4.1.9.2 1.7L20 17c0 2.2-1.8 4-4 4H8c-2.2 0-4-1.8-4-4l.6-5.6c.1-.8.1-1.3.2-1.7 0-.4.1-.6.2-.7.2-.4.5-.6.9-.8zM9 6c0-1.7 1.3-3 3-3s3 1.3 3 3zm0 5c0-.6-.4-1-1-1s-1 .4-1 1c0 2.8 2.2 5 5 5s5-2.2 5-5c0-.6-.4-1-1-1s-1 .4-1 1c0 1.7-1.3 3-3 3s-3-1.3-3-3z",
    clipRule: "evenodd",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchase);
export default __webpack_public_path__ + "static/media/purchase.4af1ffc5a9dad6c3d11f7b562b55911a.svg";
export { ForwardRef as ReactComponent };